import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sms_notifi_mgr",
  "use": "icon-sms_notifi_mgr-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-sms_notifi_mgr\"><path d=\"M56.888889 823.46666633v-568.888889l429.511111 315.733334c5.688889 5.688889 17.066667 11.377778 25.6 11.377778 8.533333 0 19.911111-2.844444 25.6-11.377778L967.111111 254.57777733v568.888889H56.888889z m455.111111-312.888889L85.333333 197.68888933h853.333334l-426.666667 312.888888z m-455.111111 369.777778h910.222222c17.066667 0 56.888889-5.688889 56.888889-56.888889v-625.777777c0-17.066667-14.222222-56.888889-56.888889-56.888889H56.888889c-51.2 0-56.888889 36.977778-56.888889 56.888889v625.777777c0 39.822222 14.222222 56.888889 56.888889 56.888889z\" p-id=\"2529\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/sms_notifi_mgr.svg
// module id = XERT
// module chunks = 115